/**
 * @flow
 * @relayHash 4d7df6d8cda7c81d86b2e870db66068f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchPageContainer_app$ref = any;
export type SearchViewAnonymousQueryVariables = {||};
export type SearchViewAnonymousQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: SearchPageContainer_app$ref
  |}
|};
export type SearchViewAnonymousQuery = {|
  variables: SearchViewAnonymousQueryVariables,
  response: SearchViewAnonymousQueryResponse,
|};
*/


/*
query SearchViewAnonymousQuery {
  app {
    ...SearchPageContainer_app
    id
  }
}

fragment SearchPageContainer_app on App {
  moneyRaised
  ...MoneyRaisedContainer_app
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchViewAnonymousQuery",
  "id": null,
  "text": "query SearchViewAnonymousQuery {\n  app {\n    ...SearchPageContainer_app\n    id\n  }\n}\n\nfragment SearchPageContainer_app on App {\n  moneyRaised\n  ...MoneyRaisedContainer_app\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchViewAnonymousQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchPageContainer_app",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchViewAnonymousQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "moneyRaised",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dollarsPerDayRate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
// prettier-ignore
(node/*: any*/).hash = '20163436c37da419f9bc157fd05f9919';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Search/__generated__/SearchViewAnonymousQuery.graphql.js